<template>
  <div class="flex align-center">
    <span>楼门户：</span>
    <div class="flex-sub flex align-center justify-between">
      <!--      <el-select v-model="project" placeholder="请选择社区" class="basis-s" @change="fristChange" disabled>-->
      <!--        <el-option-->
      <!--            v-for="item in projectList"-->
      <!--            :key="item.id"-->
      <!--            :label="item.name"-->
      <!--            :value="item.id">-->
      <!--        </el-option>-->
      <!--      </el-select>-->
      <!--      <el-select v-model="community" placeholder="请选择小区" class="basis-s" @change="secondChange" disabled>-->
      <!--        <el-option-->
      <!--            v-for="item in communityList"-->
      <!--            :key="item.id"-->
      <!--            :label="item.name"-->
      <!--            :value="item.id">-->
      <!--        </el-option>-->
      <!--      </el-select>-->
      <el-select v-model="building" placeholder="请选择楼号" class="basis-xsm" @change="thirdChange">
        <el-option
          v-for="item in buildingList"
          :key="item.id"
          :label="item.building_name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="unit" placeholder="请选择单元" class="basis-xsm" @change="fourthChange">
        <el-option
          v-for="item in unitList"
          :key="item.id"
          :label="item.element_name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="room" placeholder="请选择房间号" class="basis-xsm margin-right-sm" @change="fifthChange">
        <el-option
          v-for="item in roomList"
          :key="item.id"
          :label="item.room_name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import {getDanYuanList, getFangJianList, getLouHaoList, getXiangMuList, getXiaoQuList} from "@/api/common";

export default {
  name: "xiaoqu-level",
  props: {
    sproject: {
      type: Number,
      default: 0,
    },
    scommunity: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      projectList: [{id: 0, name: '全部社区'}],
      project: 0,
      communityList: [{id: 0, name: '全部小区'}],
      community: 0,
      buildingList: [{id: 0, building_name: '全部楼号'}],
      building: 0,
      unitList: [{id: 0, element_name: '全部单元'}],
      unit: 0,
      roomList: [{id: 0, room_name: '全部房间'}],
      room: 0,
    }
  },
  created() {
    this.project = this.sproject
    this.community = this.scommunity
    this.getLouHaoList(this.community)
  },
  components: {},
  methods: {
    async getXiangMuList() {
      let _data = await getXiangMuList()
      this.projectList = [...this.projectList, ..._data.data]
    },
    async getXiaoQuList(id) {
      let _data = await getXiaoQuList(id)
      this.communityList = [...this.communityList, ..._data.data]
    },
    async getLouHaoList(id) {
      let _data = await getLouHaoList(id)
      this.buildingList = [...this.buildingList, ..._data.data]
    },
    async getDanYuanList(id) {
      let _data = await getDanYuanList(id)
      this.unitList = [...this.unitList, ..._data.data]
    },
    async getFangJianList(id) {
      let _data = await getFangJianList(id)
      this.roomList = [...this.roomList, ..._data.data]
    },
    fristChange(e) {
      this.clearData(1)
      if (e) this.getXiaoQuList(e)
      this.upFive()
    },
    secondChange(e) {
      this.clearData(2)
      if (e) this.getLouHaoList(e)
      this.upFive()
    },
    thirdChange(e) {
      this.clearData(3)
      if (e) this.getDanYuanList(e)
      this.upFive()
    },
    fourthChange(e) {
      this.clearData(4)
      if (e) this.getFangJianList(e)
      this.upFive()
    },
    fifthChange() {
      this.upFive()
    },
    clearData(num) {
      if (num === 1) {
        this.communityList = [{id: 0, name: '全部小区'}]
        this.community = 0
        this.buildingList = [{id: 0, building_name: '全部楼号'}]
        this.building = 0
        this.unitList = [{id: 0, element_name: '全部单元'}]
        this.unit = 0
        this.roomList = [{id: 0, room_name: '全部房间'}]
        this.room = 0
      } else if (num === 2) {
        this.buildingList = [{id: 0, building_name: '全部楼号'}]
        this.building = 0
        this.unitList = [{id: 0, element_name: '全部单元'}]
        this.unit = 0
        this.roomList = [{id: 0, room_name: '全部房间'}]
        this.room = 0
      } else if (num === 3) {
        this.unitList = [{id: 0, element_name: '全部单元'}]
        this.unit = 0
        this.roomList = [{id: 0, room_name: '全部房间'}]
        this.room = 0
      } else if (num === 4) {
        this.roomList = [{id: 0, room_name: '全部房间'}]
        this.room = 0
      }
    },
    upFive() {
      this.$emit('upFive', {
        project: this.project,
        community: this.community,
        building: this.building,
        unit: this.unit,
        room: this.room
      })
    }
  },
  filters: {},
  watch: {},


}
</script>

<style scoped lang="scss">

</style>
